import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faBitcoinSign, faBank, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Link } from 'react-router-dom'

function RWithdraw() {
  const { user } = useUser(); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [admin, setAdmin] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchadmin: true })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
            setAdmin(data.admin);
        }
    })
    .catch(err => {
    })
  }, [user]);
  const [typeoptions, setTypeoptions] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchpayment: true })
    })
    .then(response =>  response.json())
    .then(data => {
      const methodop = []
      if (data.status === "success") {
        data.methods.forEach(method => {
          methodop.push({
            value: method.name,
            label: method.name,
          });
        });
        setTypeoptions(methodop);
      } 
    })
    .catch(err => {
      console.error('Error fetching withdraw method!', err);
    })
  }, [user]);
  const [activeTab, setActiveTab] = useState(localStorage.getItem('withdraw.type') || 'Crypto');
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if(activeTab){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [activeTab]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Withdraw Funds</h5>
                        <p className="mb-0">Withdraw from from your account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/rwithdraw" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Method Selection</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw11" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Withdrawal Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw12" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Withdrawal Code</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw13" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-1" style={{fontWeight:'900'}}>Select Withdrawal Method</h5>
                              <div className="row">
                                <div className="col-md-6 g-3">
                                    <div className="mycard p-3 d-flex align-items-start justify-content-between" onClick={() => setActiveTab('Crypto')}
                                      style={{border: activeTab === 'Crypto' ? '1px solid #ff6b35' : '1px solid #a9a9a90f'}}>
                                      <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{ width: '50px', height: '50px' }} >
                                          <FontAwesomeIcon icon={faBank} style={{ fontSize: '18px' }} className="text-prime"/>
                                        </div>
                                        <div className="ms-3">
                                          <p className="mb-0 fw-bold" style={{ fontSize: '18px' }}>Cryptocurrency</p>
                                          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>Fee: 0%</p>
                                            <div className="rounded-circle bg-secondary" style={{ width: '3px', height: '3px' }}></div>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>24-48 hours</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{ fontSize: '12px' }}>
                                        Popular
                                      </div>
                                    </div>
                                </div>
                                <div className="col-md-6 g-3">
                                    <div className="mycard p-3 d-flex align-items-start justify-content-between" onClick={() => setActiveTab('Bank Transfer')}
                                      style={{border: activeTab === 'Bank Transfer' ? '1px solid #ff6b35' : '1px solid #a9a9a90f'}}>
                                      <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{ width: '50px', height: '50px' }} >
                                          <FontAwesomeIcon icon={faBitcoinSign} style={{ fontSize: '18px' }} className="text-prime"/>
                                        </div>
                                        <div className="ms-3">
                                          <p className="mb-0 fw-bold" style={{ fontSize: '18px' }}>Bank Transfer</p>
                                          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>Fee: {Number(admin.retirement_fee)}%</p>
                                            <div className="rounded-circle bg-secondary" style={{ width: '3px', height: '3px' }}></div>
                                            <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>3-5 business days</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/rwithdraw1" state={{type:activeTab}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => {
                                      localStorage.setItem('withdraw.type', activeTab);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default RWithdraw